import * as LDService from '@servicetitan/launchdarkly-service';

export function getLDServiceToken() {
    return LDService.LD_SERVICE_TOKEN;
}
